function normalizer(data, state = null) {
    const output = Object.assign({}, data);

    return output;
}

export {
    normalizer,
}


// WEBPACK FOOTER //
// ./src/containers/Application/Home/pipeline.js